<div class="row justify-content-center g-0">
    <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
        <div class="d-flex justify-content-between mt-2">
            <h2>chat</h2>

            <button (click)="navigateBack()" type="button" class="btn btn-outline-dark ms-3 position-relative">
                <span class="me-1">terug naar</span>
                @if(CupOrSuperCup){
                    <app-superelf-icon [icon]=facSuperCup></app-superelf-icon>
                } @else {
                    <fa-icon [icon]=faListOl></fa-icon>
                }
                <span class="ms-1">{{nameService.getLeagueName(leagueName)}}</span>
            </button>
        </div>

        @if(!processing()) {
            @if(pool && poolPoule){
                <div>
                    <div class="d-flex justify-content-center mt-2">
                        @if(CupOrSuperCup) {
                            <h2>
                                <app-poule-title [poule]="poolPoule" [poolCompetitors]="getCompetitors(poolUsers, leagueName)"
                                (linkToPoolUser)="linkToPoolUser($event)">
                                </app-poule-title>
                            </h2>
                        }
                    </div>

                    <form name="form" (ngSubmit)="sendMessage(pool,poolUsers,poolPoule)" [formGroup]="form" novalidate>
                        <div class="d-flex justify-content-between my-2">
                            <textarea class="form-control" placeholder="plaats een bericht"
                                formControlName="message" [readonly]="processingMessage"></textarea>
                            <button type="submit" class="btn btn-primary ms-1"
                                [disabled]="processingMessage || !form.controls.message.value?.trim()">
                                <fa-icon [icon]=faPaperPlane></fa-icon>
                            </button>
                        </div>
                    </form>
                    
                    @for(message of chatMessages; track message.getId()){
                    <div class="mt-3">
                        <ng-container *ngTemplateOutlet="contentMessageTitle; context: {message, end: $index % 2 === 1}">
                        </ng-container>
                        <div class="d-flex" ngClass="{'flex-row-reverse': i % 2 === 1}"><span
                                class="badge bg-light py-3 px-2 fs-6 text-wrap text-start">{{message.getText()}}</span></div>
                    </div>
                    }
                </div>
            }
        } @else {
            <h2 class="text-center">
                <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
            </h2>
        }
    </div>
</div>

<ng-template #contentMessageTitle let-message="message" let-end="end">
    <div class="d-flex mx-1" ngClass="{'flex-row-reverse': end}">
        <fa-icon [icon]=faUserCircle></fa-icon>

        <span class="ms-1">{{message.getUser().getName()}}</span>

        <span class="mx-3">{{getMessageDate(message.getDate())}}</span>
    </div>
</ng-template>

@if(!processing && pool){
<app-pool-navbar [pool]="pool" [poolUser]="poolUserFromSession">
</app-pool-navbar>
}